<template>
    <div v-if="isShow" class="loading-wrap">
        <div id="loading">
          <div class="loadCir"></div>
          <div class="loadCir"></div>
          <div class="loadCir"></div>
          <div class="loadCir"></div>
          <div class="loadCir"></div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    isShow: Boolean
  }
}
</script>
<style lang="stylus">
.loading-wrap {
    position: fixed
    // top: 90px
    top: 0
    left: 0
    width: 100%
    height: 100%
    z-index: 999999999
    background-color: rgba(0, 0, 0, 0.2)
    img {
        @include center
        width: 3rem
    }
}
.loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  z-index: 9999;
  display: none;
}
#loading{
  position: absolute;
  left: 50%;
  top: 50%;
  width: 300px;
  height: 150px;
  margin-left: -150px;
  margin-top: -75px;
}
.loadCir {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #3A8FF9;
  float: left;
  margin: 50px 20px;
  animation: loadCir linear 1s infinite;
  -webkit-animation: loadCir linear 1s infinite;
}
.loadCir:nth-child(1){
    animation-delay:0s;
}
.loadCir:nth-child(2){
    animation-delay:0.15s;
}
.loadCir:nth-child(3){
    animation-delay:0.3s;
}
.loadCir:nth-child(4){
    animation-delay:0.45s;
}
.loadCir:nth-child(5){
    animation-delay:0.6s;
}
@keyframes loadCir
{
    0%,60%,100% {transform: scale(1);}
    30% {transform: scale(2.5);}
}
@-webkit-keyframes loadCir
{
  0%,60%,100% {transform: scale(1);}
  30% {transform: scale(2.5);}
}
</style>



// WEBPACK FOOTER //
// src/base/loading/loading.vue